// Resolve a product/image URL stored in the database.
// - If it's a relative path (e.g. "/api/static/products/abc.png"), prepend the
//   current environment's backend URL so it loads from the same origin.
// - If it's already an absolute http(s) URL, return it as-is.
export const resolveImageUrl = (url) => {
  if (!url) return "";
  if (url.startsWith("/")) {
    return `${process.env.REACT_APP_BACKEND_URL}${url}`;
  }
  return url;
};
